export const wishList = [
  {
    date: "2026-08-23",
    title: "Alternative Taxonomies",
    text: "Support taxonomic systems beyond the traditional Linnaean hierarchy, allowing users to explore biodiversity through different modern classifications and evolutionary relationships.",
  },

  {
    date: "2026-08-23",
    title: "Gallery Likes",
    text: "Implement a system where users can leave likes/kudos on the photos users display on their galleries.",
  },

  {
    date: "2026-08-23",
    title: "Creature-Collecting Titles",
    text: "Develop new unlockable titles inspired by creature-collecting games and culture, while keeping the references original enough to avoid infringing on existing intellectual property.",
  },

  {
    date: "2026-08-23",
    title: "Environmental Context",
    text: "Cross-reference photo locations with standardized global environmental datasets, such as WorldCover, MapBiomas, and climate reanalysis products, to provide habitat, land-cover, and climatic context for observations.",
  },
  {
    date: "2026-08-03",
    title: "Unlockable Frames",
    text: "Develop new unlockables, such as special frames for the gallery, or special collection covers.",
  },

  {
    date: "2026-07-29",
    title: "Photo Cropping",
    text: "Allow users to crop photos after uploading, making it easier to focus on a particular species when multiple organisms appear in the same image.",
  },

  {
    date: "2026-07-03",
    title: "National Species",
    text: "Develop little medals that you can attach to your profile when you photograph that national bird, plant, or other species of a country.",
  },
  {
    date: "2026-06-07",
    title: "Location Explore Mode Search Function",
    text: "Develop a search bar in the location explore mode that allows you to search, or select from locations, which will then yield some date buttons for those locations.",
  },
  {
    date: "2026-06-03",
    title: "Drag Photos into Collections",
    text: "Allow photos displayed throughout Explore Taxonomy to be dragged directly into collections, providing a faster and more intuitive way to organize observations.",
  },
  {
    date: "2026-06-03",
    title: "Improve Mobile Collection Reordering",
    text: "Refine collection photo reordering on mobile devices to provide smoother drag-and-drop interactions and more reliable positioning of photos within custom collection layouts.",
  },

  {
    date: "2026-05-01",
    title: "Notification Settings",
    text: "Allow users to customize notifications for friend requests, shared activity, collection updates, quiz invitations, and other Bioindex interactions.",
  },
  {
    date: "2026-05-01",
    title: "Mobile App Deployment",
    text: "Deploy Bioindex as a dedicated phone app to improve mobile access, enable app-specific features, and provide a smoother experience for uploading, browsing, and organizing biodiversity records.",
  },
  {
    date: "2026-05-01",
    title: "iNaturalist Species Identification",
    text: "Integrate iNaturalist-powered species identification so users can receive suggested identifications for uploaded photos while maintaining Bioindex as a personal taxonomy archive.",
  },
  {
    date: "2026-05-01",
    title: "Personal Tree of Life",
    text: "Create a full Tree of Life view that connects all uploaded species photos into one interactive taxonomic structure, allowing users to explore their entire collection from broad groups down to individual species records.",
  },
  {
    date: "2026-04-28",
    title: "Spatial Location Data",
    text: "Implement structured spatial variables for location data, moving beyond free-text location fields to support standardized geographic information such as country, region, city, coordinates, and mapped collection points.",
  },
  {
    date: "2026-04-28",
    title: "Geography-Based Quizzes",
    text: "Allow users to create quizzes based on geographic filters such as country, city, region, or other location-based groupings, making it possible to test biodiversity knowledge by place as well as taxonomy or collection.",
  },
  {
    date: "2026-04-15",
    title: "Shared Albums",
    text: "Allow for friends to make a joint album or merge albums that they can then quiz together.",
  },
  {
    date: "2026-04-12",
    title: "Allow Sorting of Cards",
    text: "Allow users to sort cards by abundance, size, or other characteristics.",
  },
  {
    date: "2026-04-02",
    title: "No Login Visit",
    text: "Allow users to view my personal collection with a link that does not require login but does not allow for anything else.",
  },
  {
    date: "2026-03-17",
    title: "Photos not IDed to Species",
    text: "Allow users to upload photos of species that they do not have an ID for and can later specify.",
  },
  {
    date: "2026-03-17",
    title: "Full and update taxonomy",
    text: "Currently we only include the full and update taxonomy for Aves. Others remain incomplete or outdated.",
  },
  {
    date: "2026-03-17",
    title: "Achievement notifications",
    text: "Display small in-app notifications when users unlock titles, badges, or milestones to reinforce progress.",
  },
  {
    date: "2026-03-17",
    title: "Species badges",
    text: "Users earn illustrated badges for reaching milestones within taxonomic groups (e.g., 10, 25, 50 species in a family). Badges should follow the same naturalist illustration style as the rest of the app.",
  },
  {
    date: "2026-03-17",
    title: "Photo and icon compression",
    text: "Include compression of photos to speed up database access, with an option to download full resolution versions. The same should apply to icons, which are currently large high-resolution images.",
  },
  {
    date: "2026-03-17",
    title: "Photo quality scoring system",
    text: "Add a system to evaluate how good a picture is (e.g. subject in frame, blur, size, resolution) and use it as a gamified metric.",
  },
  {
    date: "2026-03-17",
    title: "User-based photo rating",
    text: "Provide an option for users to rate other people’s photos, using a social system instead of relying entirely on automated evaluation.",
  },
  {
    date: "2026-03-17",
    title: "Suggest missing local species",
    text: "Provide an option to show which species a user is missing from their area to encourage going out and taking photos.",
  },
  {
    date: "2026-03-17",
    title: "Life list tracker",
    text: "A dedicated page showing total species recorded, broken down by taxonomic level, with progress bars and percentages to visualize collection completeness.",
  },
  {
    date: "2026-03-17",
    title: "Offline upload queue",
    text: "Allow users to upload photos without connection; images are stored locally and automatically uploaded once connectivity is restored.",
  },
  {
    date: "2026-03-17",
    title: "Field notes per species",
    text: "Each species entry includes a small notes section where users can write observations such as behavior, habitat, or encounter details.",
  },
  {
    date: "2026-03-17",
    title: "Map of observations",
    text: "Display a simple map showing where each species was recorded, based on optional geolocation data attached to photos.",
  },
  {
    date: "2026-03-17",
    title: "Streak system",
    text: "Track consecutive days or weeks of adding new species or photos, rewarding consistency with visual indicators.",
  },
  {
    date: "2026-03-17",
    title: "Export life list",
    text: "Allow users to export their species list as CSV or PDF for personal records or research use.",
  },
  {
    date: "2026-03-17",
    title: "Private vs public species",
    text: "Give users control over whether a species entry is visible to friends or kept private.",
  },
];
